import React from 'react';

const MyBooks = () => {
  return <div className='p-10 text-[#0037c3]'>MyBooks</div>;
};

export default MyBooks;
